export const localStorageGhostModeName = 'ghostModeParams';
